import { Base64 } from 'js-base64'

/**
 * base64编码
 * @param {*} content 要编码内容
 * @param {*} encoding 编码字符集（默认UTF-8）
 * @returns 编码后的内容
 */
export function encode(content, encoding) {
  return Base64.encode(content, encoding || 'utf-8')
}

/**
 * base64解码
 * @param {*} content 要解码内容
 * @param {*} encoding 解码字符集（默认UTF-8）
 * @returns 解码后的内容
 */
export function decode(content, encoding) {
  return Base64.decode(content, encoding || 'utf-8')
}
